import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { BoardToolbarAction } from "shared/constants/toolbar"

interface ModalState {
    type: BoardToolbarAction | null;
  context: 'board' | 'asset' | 'mixed' | 'chat' | null;
    data: {
      ids: string[];
      items: any[];
      parentId?: string;
      redirectTo?: string
    } | null;
  }
  
const initialState: ModalState = {
  type: null,
  context: null,
  data: null,
}
  
const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<Omit<ModalState, 'data'> & { data?: ModalState['data'] }>) => {
      state.type = action.payload.type
      state.context = action.payload.context
      state.data = action.payload.data || null
    },
    closeModal: (state) => {
      state.type = null
      state.data = null
      state.context = null
    },
  },
})

export const { openModal, closeModal } = modalSlice.actions
export const modalReducer = modalSlice.reducer